import { createSignal } from "solid-js";
import { signalExtender } from "../../../utils/signal.js";
function createResettable(value, options) {
    return createResettable.wrap(createSignal(value, options));
}
createResettable.wrap = (signal) => {
    const initial = signal[0]();
    return signalExtender(signal).extend(([, setState]) => [
        {},
        {
            reset() {
                setState(initial);
            },
        },
    ]);
};
export default createResettable;
